import menu from "./menu"
import userReducer from "./../slice/userSlice"
import dashboardReducer from "../slice/dashboardSlice"
import locationReducer from "../slice/locationSlice"
import providerReducer from "../slice/providerSlice"
import appointmentReducer from "./../slice/appointmentSlice"
import ratingReducer from "./../slice/ratingSlice"
import usersReducer from "./../slice/usersSlice"
import commonReducer from "./../slice/commonSlice"
import adminReducer from "./../slice/adminSlice"
//combining reducers to single object

const reducers = {
  menu,
  user: userReducer,
  dashboard: dashboardReducer,
  location: locationReducer,
  providers: providerReducer,
  appointments: appointmentReducer,
  ratings: ratingReducer,
  users: usersReducer,
  common: commonReducer,
  admin: adminReducer,
}
export default reducers
